import { render, staticRenderFns } from "./Asegurados.vue?vue&type=template&id=09ca22cc&scoped=true&"
import script from "./Asegurados.vue?vue&type=script&lang=js&"
export * from "./Asegurados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca22cc",
  null
  
)

export default component.exports